const s = {
  name: "Feedback2",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36.4" style="enable-background:new 0 0 40 36.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M16.3,8.1C16.1,5.9,17.8,4,20,4s3.9,1.9,3.7,4.1l-0.6,7l0,0C23,16.7,21.6,18,20,18c-1.7,0-3-1.3-3.2-2.9l0,0
	L16.3,8.1z M18.2,7.9l0.6,7c0.1,0.6,0.6,1.1,1.2,1.1c0.6,0,1.1-0.5,1.2-1.1l0,0l0.6-7C21.8,6.9,21,6,20,6C19,6,18.2,6.9,18.2,7.9z"
	/>
<path class="st0" d="M17,22c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3C18.3,25,17,23.7,17,22z M20,21c-0.5,0-1,0.5-1,1
	c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1C21,21.5,20.5,21,20,21z"/>
<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v19c0,2.8,2.2,5,5,5h4v7.4l7.4-7.4H35c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5
	c0-1.7,1.3-3,3-3h30c1.7,0,3,1.3,3,3v19c0,1.7-1.3,3-3,3H15.6L11,31.6V27H5c-1.7,0-3-1.3-3-3V5z"/>
</svg>
  `
};
export {
  s as Feedback2
};
